import { FormControls } from '@elementary/common-ui/components';
import { UseFormWatch } from 'react-hook-form';
import SeverityRenderer from 'shared/components/SeverityRenderer';
import { AddTestForm } from 'shared/types';

const detectionTypeLabelMap = {
  anomaly: 'anomalies',
  drop: 'drops',
  spike: 'spikes',
};

type Props = {
  watch: UseFormWatch<AddTestForm>;
};

const TablesVolumeAnomaliesConfig = ({ watch }: Props) => (
  <>
    {watch('timestampColumn') && (
      <FormControls.FormText>
        Timestamp column: <b>{watch('timestampColumn')}</b>
      </FormControls.FormText>
    )}

    <FormControls.FormText>
      Detect <b>{detectionTypeLabelMap[watch('detectionEventType')]}</b> in the
      size and growth of a table by comparing the row count of each{' '}
      <b>
        {watch('detectionPeriod')} {watch('detectionUnit')}
      </b>{' '}
      period to the last <b>{watch('detectionDaysBack')}</b> days
    </FormControls.FormText>

    <SeverityRenderer severity={watch('severity')?.type || 'error'} />
  </>
);

export default TablesVolumeAnomaliesConfig;
